import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-twenty',
  templateUrl: './home-twenty.component.html',
  styleUrls: ['./home-twenty.component.scss']
})
export class HomeTwentyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
